<template>
  <v-app>
    <v-main class="disabled-bg">
      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="5">
            <v-card class="pa-8 text-center" elevation="4" rounded="lg">
              <v-icon size="80" color="orange darken-2" class="mb-4">mdi-account-lock-outline</v-icon>

              <h1 class="text-h5 font-weight-bold mb-2">Account Disabled</h1>

              <p class="text-body-1 grey--text text--darken-1 mb-6">
                Your account has been disabled. If you believe this is a mistake or would like to
                re-enable it, please reach out to our support team.
              </p>

              <v-btn
                color="primary"
                large
                href="mailto:support@crawlo.com"
                class="text-none mb-4"
              >
                <v-icon left>mdi-email-outline</v-icon>
                Contact Support
              </v-btn>

              <div class="mt-4">
                <v-btn text small color="grey darken-1" @click="logout" class="text-none">
                  <v-icon left small>mdi-logout</v-icon>
                  Sign out
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'AccountDisabled',
  methods: {
    logout() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push('/login')
      })
    },
  },
}
</script>

<style scoped>
.disabled-bg {
  background: #f5f5f5;
}
</style>
